<!-- 由 suu 创建于 2022-01-07 星期五 -->
<template>
  <div class="ItemDatas">
    <div
      class="id-item"
      :class="{ 'id-item-risk': item.risk, 'id-item-empty': !item.title }"
      v-for="(item, index) in listO"
      :key="index"
    >
      <template v-if="item.title">
        <div class="i-top">
          <div class="i-title">{{ item.title }}</div>
          <div class="i-sub">
            {{ `${item.sub ? item.sub + '：' : ''}${item.subValue}` }}
          </div>
          <div class="i-sub" v-if="item.third">
            {{ `${item.third ? item.third + '：' : ''}${item.thirdValue}` }}
          </div>
        </div>
        <div class="i-nums">
          <div class="num-left">
            <template v-if="item.all">
              <div class="l-val">{{ item.value }}/</div>
              <div class="l-all">{{ item.all }}{{ item.unit }}</div>
            </template>
            <div class="l-val" v-else>{{ item.value }}{{ item.unit }}</div>
          </div>
          <div class="num-more" v-if="item.more" @click="handelClickMore(item)">
            {{ item.more }}>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemDatas',

  components: {},

  props: {
    list: {
      type: Array,
      require: true
    }
  },

  data() {
    return {}
  },

  computed: {
    listO() {
      // flex布局 尾部加项
      const list = this.list
      for (
        let index = 0;
        index < list.length % 3 ? 3 - (list.length % 3) : 0;
        index++
      ) {
        list.push({})
      }
      return list
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 点击查看/更多 跳转
    handelClickMore(item) {
      console.log('====================================')
      console.log(
        '跳转更多',
        item.moreUrlMini +
          `?title=${this.$parent.info.name}&alias=${this.$parent.info.alias}&pid=${this.$parent.info.pid}`
      )
      console.log('====================================')
      // 小程序
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          wx.miniProgram.navigateTo({
            url:
              item.moreUrlMini +
              `?title=${this.$parent.info.name}&alias=${this.$parent.info.alias}&pid=${this.$parent.info.pid}`
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ItemDatas {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .id-item {
    width: 100px;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 8px 10px;
    padding-right: 6px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
    margin-bottom: 6px;
    .i-top {
      width: 100%;
      box-sizing: border-box;
    }
    .i-title {
      font-size: 13px;
      font-weight: 500;
    }
    .i-sub {
      display: flex;
      align-items: center;
      font-size: 10px;
      color: #7b7b7b;
      margin-top: 2px;
    }
    .i-nums {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      .num-left {
        display: flex;
        align-items: baseline;
        color: #000000;
        .l-val {
          font-size: 15px;
          font-weight: 500;
        }
        .l-all {
          font-size: 10px;
        }
      }
      .num-more {
        font-size: 10px;
        font-weight: 500;
        color: #2882e9;
      }
    }
  }
  .id-item-risk {
    background: rgba(240, 70, 70, 0.06);
    border: 1px solid #ffe6e6;
    .num-left {
      color: #f04646 !important;
    }
  }
  .id-item-empty {
    border: none;
  }
}
</style>
